import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import aboutUs from '@/components/aboutUs'
import article from '@/components/article'



Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',                              //首页
      component: index,
      children: [
        {
          path: '/index',                               //首页
          component: index
        }     
        
      ]
   },
   {
    path: '/aboutUs',                  //关于学为
    component: aboutUs
   },
   {
    path: '/article',                  //资讯
    component: article
   },
   


  ]
})
